import { Language } from '~common/i18n';
import { getMarketplaceAdditionalDetailsRequest } from '~admin/view/components/create-event/helper/marketplace-request/marketplace-additional-details-request.helper';
import { getMarketplaceBaseDetailsRequest } from '~admin/view/components/create-event/helper/marketplace-request/marketplace-base-details-request.helper';
import { getMarketplaceDatetimeDetailsRequest } from '~admin/view/components/create-event/helper/marketplace-request/marketplace-datetime-details-request.helper';
import {
  arrayTranslations,
  mergeTranslations,
} from '~admin/view/components/create-event/helper/merge-translations.helper';
import { MarketplaceFormData } from '~admin/view/components/details/marketplace-details/marketplace-details-fields.component';
import { MarketplaceRequest } from '~client/model/admin/marketplace-request';
import { MarketplaceTranslationRequestItem } from '~client/model/admin/marketplace-translation-request-item';
import { MarketplaceTranslationsRequest } from '~client/model/admin/marketplace-translations-request';

/**
 * Transforms MarketplaceFormData to MarketplaceRequest
 * @param eventId
 * @param marketplaceFormData
 */
export const getMarketplaceRequest = (
  eventId: number,
  marketplaceFormData: MarketplaceFormData,
): MarketplaceRequest => {
  const marketplaceBaseRequest = getMarketplaceBaseDetailsRequest(marketplaceFormData);
  const marketplaceDatetimeRequest = getMarketplaceDatetimeDetailsRequest(marketplaceFormData);
  const marketplaceAdditionalRequest = getMarketplaceAdditionalDetailsRequest(marketplaceFormData);

  return {
    eventId,
    ...marketplaceBaseRequest,
    ...marketplaceDatetimeRequest,
    ...marketplaceAdditionalRequest,
  };
};

export const getMarketplaceTranslationsRequest = (
  marketplaceId: string,
  values: MarketplaceFormData,
): MarketplaceTranslationsRequest => {
  const { capacity, rules } = values;

  const marketplaceTranslations = new Map<Language, MarketplaceTranslationRequestItem>();
  mergeTranslations(marketplaceTranslations, 'capacityDefaultString', capacity);
  mergeTranslations(marketplaceTranslations, 'rules', rules);

  return {
    marketplaceId,
    marketplaceTranslationRequestItemList: arrayTranslations(marketplaceTranslations),
  };
};



// WEBPACK FOOTER //
// ./view/components/create-event/helper/marketplace-request.helper.ts